require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./del-respect-a-elegir-a-rusia-como-sede-del-mundial.json") })
        }
      }, "path---del-respect-a-elegir-a-rusia-como-sede-del-mundial");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---del-respect-a-elegir-a-rusia-como-sede-del-mundial!./.cache/json/del-respect-a-elegir-a-rusia-como-sede-del-mundial.json
// module id = 444
// module chunks = 231608221292675